var _rect, _rect2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarriageLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 32,
    viewBox: "0 0 78 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30.4771,
    height: 30.4771,
    fill: "white",
    stroke: "#0E0F10"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8413,
    y: 0.5,
    width: 30.4771,
    height: 30.4771,
    rx: 15.2385,
    fill: "white",
    stroke: "#0E0F10"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30.6025,
    y1: 16.1133,
    x2: 46.3411,
    y2: 16.1133,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarriageLine);
export default __webpack_public_path__ + "static/media/marriage-line.fb4706327f41ed2a73e1f0620eca5ec5.svg";
export { ForwardRef as ReactComponent };